import axios from "axios";
import _, { get } from "lodash";
import React from "react";
import { BASE_URL } from "../../../consts/app.consts";
import { BadgeCell, DefaultCell, ResourcePersonCell } from "./components/cells";
import * as Yup from 'yup';
import { printAction } from "../../../actions";

const StudentCreditDetailsConfig = {
    searchApi: "xceed.api.report.student.get_credit_details_report",
    excelFileName: "credit-report",
    title: "Student Credit Details Report",
    extraActionsAsMenu: true,
    sections: [
        {
            selectionTitle: "Filters",
            grid: { base: 1, md: 2, lg: 4, xl: 4 },
            filters: [
                {
                    is_required: true,
                    label: "Student",
                    key: "student",
                    onChange: (formik: any) => {
                        if (!formik.values.student) {
                            formik.setFieldValue('program', '')
                        }
                    },
                    type: "form-online-search",
                    validationSchema: Yup.string().required("Student is required"),
                    methodBody: {
                        "student": "student"
                    },
                    optionMethod: "xceed.api.report.student.get_students_dd",
                },
                {
                    is_required: true,
                    label: "Program",
                    key: "program",
                    validationSchema: Yup.string().required("Program is required"),
                    type: "form-select",
                    methodBody: {
                        "student": "student"
                    },
                    optionMethod: "xceed.api.report.student.get_programs_dd",
                },
            ],
        },
    ],

    tableConfig: {
        column: [
            {
                header: "Module",
                accessor: "module",
                customRenderer: (value: any, item: any) =>
                    React.createElement(BadgeCell, {
                        config: statusBadgeConfig,
                        value: value,
                    }),
                width: 500,
            },
            {
                header: "credit",
                accessor: "credit",
                width: 500,
            }
        ],
    },
    actions: [
        {
            text: "Print Report",
            onClick: async (filter: any, data: any, setLoading: any) => {
                if (filter.student && filter.program) {
                    setLoading(true);
                    try {

                        await printAction('xceed.api.print.print_student_credit_details_report', { filter }, setLoading);
                        setLoading(false);
                    } catch (error: any) {
                        setLoading(false);
                        const newError: any = new Error("Unable to Generate Excel file");
                        newError.title = "Error";
                        newError.status = "error";
                        throw newError;
                    }
                } else {
                    const error: any = new Error(
                        "Please select student and program"
                    );
                    error.title = "Warning";
                    error.status = "warning";
                    throw error;
                }
            },
            buttonVariant: "solid",
            buttonColorScheme: "teal",
        },
    ],
};

export default StudentCreditDetailsConfig;

const statusBadgeConfig = {
    NO: "bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded",
    YES: "bg-red-100 text-red-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded",
};
